import React, { createContext, Dispatch, memo, SetStateAction, useContext } from 'react';

const CardIdContext = createContext<string | null>(null);

const CardIdProviderComponent = (props: React.PropsWithChildren<{ id: string }>) => (
  <CardIdContext.Provider value={props.id}>{props.children}</CardIdContext.Provider>
);

export const CardIdProvider = memo(CardIdProviderComponent);

export const useCardId = (): string => useContext(CardIdContext) as string;

/**
 * Used Internally by card to open kebab options
 */
const KebabContext = createContext<
  [HTMLButtonElement | null, Dispatch<SetStateAction<HTMLButtonElement | null>>] | null
>(null);

export const KebabProvider = (props: React.PropsWithChildren<any>) => {
  const sd = React.useState<HTMLButtonElement | null>(null);
  return <KebabContext.Provider value={sd}>{props.children}</KebabContext.Provider>;
};

export const useKebab = () =>
  useContext(KebabContext) as [
    HTMLButtonElement | null,
    Dispatch<SetStateAction<HTMLButtonElement | null>>
  ];
